import { render, staticRenderFns } from "./MenuLink.vue?vue&type=template&id=4bff5cce"
import script from "./MenuLink.vue?vue&type=script&lang=js"
export * from "./MenuLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bff5cce')) {
      api.createRecord('4bff5cce', component.options)
    } else {
      api.reload('4bff5cce', component.options)
    }
    module.hot.accept("./MenuLink.vue?vue&type=template&id=4bff5cce", function () {
      api.rerender('4bff5cce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/Sidebar/MenuLink.vue"
export default component.exports